export default "{\n    \"heading\": \"Construcción\",\n    \"headings\": {\n        \"newProject\": \"Nuevo Proyecto\"\n    }\n}\n"